import React, { useState, useEffect, useCallback } from 'react';
import DetailCard from './DetailCard/DetailCard';
import CustomerDetails from './CustomerDetails/CustomerDetails';
import CustomerForm from '../../../components/forms/CustomerForm/CustomerForm';
import ProjectForm from '../../../components/forms/ProjectForm/ProjectForm';
import TaskForm from '../../../components/forms/TaskForm/TaskForm';
import './Home.css';
import 'moment-timezone';
import { APIURL } from '../../../config';
import axios from 'axios';
import moment from 'moment';
import { IconButton, Dialog, DialogActions, DialogContent, Grid, Menu, MenuItem, ListItemIcon, Button, Chip, Avatar, Box, Stack, LinearProgress, Divider, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import PersonIcon from '@mui/icons-material/Person';
import MapsBar from '../../MapsBar/MapsBar';

const Home = (props) => {
  const [showMap, setShowMap] = useState(false);
  const [contextMenu, setContextMenu] = useState(0);
  const [customerStatus, setCustomerStatus] = useState([]);
  const [customerType, setCustomerType] = useState([]);
  const [loc_list, setLocList] = useState([]);
  const [employee_list, setEmployeeList] = useState([]);
  const [project_tasks, setProjectTasks] = useState([]);
  const [payerList, setPayerList] = useState([]);
  const [programList, setProgramList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [taskType, setTaskType] = useState([]);
  const [quickActionAnchor, setQuickActionAnchor] = useState(null);
  const [notesOpen, setNotesOpen] = useState(false);

  const [schemaLocal, setSchemaLocal] = useState(props.schema);
  const [schemaDefaultsLocal, setSchemaDefaultsLocal] = useState(props.schemaDefaults);

    const getSchemaInfo = (field) => {
        const info = schemaLocal?.find(s => s.columnName?.toLowerCase() === field.toLowerCase())
            || schemaDefaultsLocal?.find(s => s.columnName?.toLowerCase() === field.toLowerCase())
            || {};
        return info;
    };
    const isFieldVisible = (field) => {
        const info = getSchemaInfo(field);
        // If columnVisible is undefined, default to true (show field)
        return info.columnVisible !== undefined ? !!info.columnVisible : true;
    };
    const getFieldLabel = (field, fallback) => getSchemaInfo(field).columnLabel || fallback;

  useEffect(() => {
      const fetchSchema = async () => {
        try {
          const [schRes, defRes] = await Promise.all([
            axios.get(`${APIURL}/schema/table/project`, { params: { companyID: props.comp_id } }),
            axios.get(`${APIURL}/schema/table-default/project`, {
              params: {
                companyState: props.user.comp_settings.find(s => s.feature_id === 99)?.state_id || null,
                companyTypeOfBusiness: props.user.comp_settings.find(s => s.feature_value === 'primaryBusinessType')?.feature_id || null,
              }
            })
          ]);
          setSchemaLocal(schRes.data);
          setSchemaDefaultsLocal(defRes.data);
        } catch (err) {
          console.error('Failed to fetch schema for CustomerForm', err);
        }
      };
      if (!props.schema || !props.schemaDefaults) fetchSchema();
    }, []);

  const fetchData = useCallback(async () => {
    let project_tasks = await axios.get(APIURL + '/project/projTask', { params: { proj_id: props.id } });
    let customerStatus = await axios.get(APIURL + '/dropdowns/dropdownType/customerStatus', { params: { comp_id: props.comp_id } });
    let customerType = await axios.get(APIURL + '/dropdowns/dropdownType/customerType', { params: { comp_id: props.comp_id } });
    let loc_list = await axios.get(APIURL + '/dropdowns/dropdownType/locationslist', { params: { comp_id: props.comp_id } });
    let employee_list = await axios.get(APIURL + '/dropdowns/dropdownType/employeeslist', { params: { comp_id: props.comp_id } });
    let taskTypes = await axios.get(APIURL + '/dropdowns/dropdownType/taskType', { params: { comp_id: props.comp_id, employeeType: props.user.type } });
    let payerDetails = await axios.get(APIURL + `/associate_payer`, {
      params: {
        compId: props.comp_id,
      },
    });
    let programs = await axios.get(`${APIURL}/programs`, {
      params: { company_id: props.comp_id },
    });
    const filteredPayerDetails = payerDetails.data.filter((p) => p.id);
    setCustomerStatus(customerStatus.data);
    setCustomerType(customerType.data);
    setLocList(loc_list.data);
    setEmployeeList(employee_list.data);
    setProjectTasks(project_tasks.data);
    setTaskType(taskTypes.data);
    setPayerList(filteredPayerDetails);
    setProgramList(Array.isArray(programs.data) ? programs.data : []);
    setLoading(false);
  }, [props.id, props.comp_id]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setLoading(true);
    fetchData();
    // eslint-disable-next-line
  }, [props.id]);

  const navigationHandler = (contextMenu) => {
    setContextMenu(contextMenu);
  };

  const showProjectStatus = () => {
    if (props.status) {
      return 'Ongoing';
    } else {
      return 'Completed';
    }
  };

  const getStatusMeta = (t) => {
    const now = moment();
    if (t.tas_is_active === 2) return { label: 'Inactive', bg: '#eceff1', color: '#607d8b' };
    if (moment(t.tas_end_date).isBefore(now)) return { label: 'Completed', bg: '#e8f5e9', color: '#2e7d32' };
    if (moment(t.tas_start_date).isAfter(now)) return { label: 'Scheduled', bg: '#fff3e0', color: '#e65100' };
    return { label: 'In Progress', bg: '#e3f2fd', color: '#1565c0' };
  };

  const isFollowUpTask = (task) => {
    const text = `${task?.tas_type || ''} ${task?.tas_title || ''}`.toLowerCase();
    return text.includes('follow up') || text.includes('follow-up');
  };

  const getInitials = (name) => (name || '?').split(' ').filter(Boolean).map((s) => s[0]).slice(0, 2).join('').toUpperCase();

  const getProjectLocation = () => {
    let proj_loc_list = props.locations;
    let filtered_loc_list = [];
    proj_loc_list.forEach((loc) => {
      filtered_loc_list.push(loc_list.filter((loc1) => loc1.id === loc.loc_id)[0]);
    });
    return filtered_loc_list;
  };

  const generateMapsData = () => {
    return (props.locations || []).map((loc) => ({
      location: [+loc.loc_lat || 0, +loc.loc_lon || 0],
      addHandler: 'mouseover',
      infoboxOption: {
        title: props.customer_details[0]?.cus_name || '',
        description: [loc.loc_addr_line1, loc.loc_addr_line2, loc.loc_city, loc.loc_state, loc.loc_zip].filter(Boolean).join(', '),
      },
      pushPinOption: { color: 'red', title: props.title },
    }));
  };

  const toggleMap = () => setShowMap((p) => !p);

  let content = null;
  if (contextMenu === 1) {
    content = (
      <Dialog fullWidth={true} maxWidth={'sm'} open={contextMenu === 1} onClose={() => navigationHandler(0)}>
        <DialogContent>
          <CustomerDetails
            history={props.history}
            onClickBack={navigationHandler}
            onClickEdit={navigationHandler}
            customer_details={props.customer_details[0]}
            projectTitle={props.title}
          />
        </DialogContent>
      </Dialog>
    );
  } else if (contextMenu === 0 || contextMenu === 4) {
    const statusLabel = showProjectStatus();
    const isOngoing = !!props.status;
    const managerName = employee_list.filter((emp) => emp.id === props.project_details.pro_manager_id)[0]?.employee_name || 'N/A';
    const programName = programList.find(program =>
      String(program.program_id) === String(props.project_details.pro_program_id)
    )?.program_name;
    const customerName = props.customer_details[0]?.cus_name || 'N/A';
    const allTasks = project_tasks || [];
    const widgetTasks = allTasks.filter((t) => !isFollowUpTask(t));

    // ----- Pulse Bar metrics -----
    const startM = moment(props.start_date.replace(/Z/g, ''));
    const endM = moment(props.end_date.replace(/Z/g, ''));
    const totalDur = endM.diff(startM);
    const elapsed = moment().diff(startM);
    const budgetPct = totalDur > 0 ? Math.min(Math.max(Math.round((elapsed / totalDur) * 100), 0), 100) : 0;

    const completedCount = widgetTasks.filter((t) => t.tas_is_active === 2 || moment(t.tas_end_date).isBefore(moment())).length;
    const totalCount = widgetTasks.length;

    const upcoming = widgetTasks
      .filter((t) => moment(t.tas_start_date).isAfter(moment()))
      .sort((a, b) => moment(a.tas_start_date) - moment(b.tas_start_date));
    const nextMilestone = upcoming[0];

    // ----- Task list (respect visibility) -----
    const visibleTasks = (props.user.type === 'Admin' || props.user.type === 'Manager')
      ? widgetTasks
      : widgetTasks.filter((tas) => tas.tas_emp_id === props.user.emp_id);
    const displayTasks = [...visibleTasks]
      .filter((t) => t.tas_is_active !== 2)
      .sort((a, b) => moment(b.tas_start_date) - moment(a.tas_start_date));

    const renderRow = (label, value) => (
      <div className="detail-row">
        <span className="detail-label">{label}</span>
        <span>{value === null || value === undefined || value === '' ? 'N/A' : value}</span>
      </div>
    );

    const placeholderFields = [
      { field: 'place01char', type: 'text', fallback: 'Placeholder 01' },
      { field: 'place02char', type: 'text', fallback: 'Placeholder 02' },
      { field: 'place03char', type: 'text', fallback: 'Placeholder 03' },
      { field: 'place04date', type: 'date', fallback: 'Placeholder 04' },
      { field: 'place05date', type: 'date', fallback: 'Placeholder 05' },
      { field: 'place06number', type: 'number', fallback: 'Placeholder 06' },
      { field: 'place07number', type: 'number', fallback: 'Placeholder 07' },
    ];

    content = (
      <>
      <Dialog fullWidth={true} maxWidth={'sm'} open={contextMenu === 4} onClose={() => navigationHandler(0)}>
        <DialogContent>
          <TaskForm
            mapRender={"task"}
            history={props.history}
            isFormValidated={props.isFormValidated}
            projList={[props.project_details]}
            defaultProjectId={props.project_details.pro_id}
            defaultCustomerId={props.project_details.pro_customer_id}
            taskType={taskType}
            taskList={project_tasks}
            locList={loc_list}
            empList={(props.empList || []).map(emp => ({
              id: emp.emp_id ?? emp.id,
              employee_name: emp.employee_name ?? `${emp.emp_first_name || ''} ${emp.emp_last_name || ''}`.trim(),
              emp_type: emp.emp_type,
              emp_timezone: emp.emp_timezone,
            }))}
            comp_id={props.comp_id}
            user={props.user}
            goHome={() => { navigationHandler(0); fetchData(); }}
          />
        </DialogContent>
      </Dialog>

      <div className="proj-overview-redesign" style={{ height: '100%', display: 'flex', flexDirection: 'row', overflow: 'hidden', gap: '16px' }}>
        <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: '16px', overflow: 'hidden' }}>
        {/* ===== HEADER + QUICK ACTION ===== */}
        <div className="proj-snapshot-header">
          <div className="proj-title-group">
            <span className="proj-title">{props.title}</span>
            <Button
              variant="contained"
              endIcon={<ArrowDropDownIcon />}
              onClick={(e) => setQuickActionAnchor(e.currentTarget)}
              sx={{ fontWeight: 700, fontSize: '0.78rem', px: 2 }}
            >
              Quick Action
            </Button>
            <Menu
              anchorEl={quickActionAnchor}
              open={Boolean(quickActionAnchor)}
              onClose={() => setQuickActionAnchor(null)}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              PaperProps={{
                elevation: 3,
                sx: {
                  mt: 0.5,
                  minWidth: 210,
                  borderRadius: '8px',
                  border: '1px solid #e0ecfa',
                  '& .MuiMenuItem-root': {
                    fontSize: '0.82rem',
                    fontWeight: 500,
                    py: 0.9,
                    px: 1.5,
                    borderRadius: '6px',
                    mx: 0.5,
                    '&:hover': { bgcolor: '#f0f7ff' },
                  },
                },
              }}
            >
              <Box sx={{ px: 2, pt: 1, pb: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 800, color: '#aaa', letterSpacing: '0.07em', textTransform: 'uppercase', fontSize: '0.68rem' }}>
                  Project
                </Typography>
              </Box>
              <MenuItem onClick={() => { setQuickActionAnchor(null); navigationHandler(4); }}>
                <ListItemIcon sx={{ minWidth: 30 }}><AddIcon fontSize="small" sx={{ color: '#3fa7d6' }} /></ListItemIcon>
                New Task
              </MenuItem>
              <MenuItem onClick={() => { setQuickActionAnchor(null); navigationHandler(3); }}>
                <ListItemIcon sx={{ minWidth: 30 }}><EditIcon fontSize="small" sx={{ color: '#3fa7d6' }} /></ListItemIcon>
                Edit Project
              </MenuItem>
              <Divider sx={{ my: 0.5, mx: 1 }} />
              <Box sx={{ px: 2, pt: 0.5, pb: 0.5 }}>
                <Typography variant="caption" sx={{ fontWeight: 800, color: '#aaa', letterSpacing: '0.07em', textTransform: 'uppercase', fontSize: '0.68rem' }}>
                  Customer
                </Typography>
              </Box>
              <MenuItem onClick={() => { setQuickActionAnchor(null); navigationHandler(1); }}>
                <ListItemIcon sx={{ minWidth: 30 }}><PersonIcon fontSize="small" sx={{ color: '#888' }} /></ListItemIcon>
                Customer Details
              </MenuItem>
              <MenuItem onClick={() => { setQuickActionAnchor(null); navigationHandler(2); }}>
                <ListItemIcon sx={{ minWidth: 30 }}><EditIcon fontSize="small" sx={{ color: '#888' }} /></ListItemIcon>
                Edit Customer
              </MenuItem>
              <Box sx={{ pb: 0.5 }} />
            </Menu>
          </div>
          <Chip
            size="small"
            label={statusLabel}
            sx={{ fontWeight: 700, bgcolor: isOngoing ? '#e8f5e9' : '#eceff1', color: isOngoing ? '#2e7d32' : '#555' }}
          />
        </div>

        {/* ===== PULSE BAR ===== */}
        <div className="pulse-bar">
          <div className="pulse-item">
            <div className="pulse-value">{budgetPct}%</div>
            <LinearProgress variant="determinate" value={budgetPct} sx={{ height: 6, borderRadius: 3, my: 0.5 }} />
            <div className="pulse-label">Time Budget Used</div>
          </div>
          <div className="pulse-divider" />
          <div className="pulse-item">
            <div className="pulse-value">{completedCount} / {totalCount} Tasks</div>
            <div className="pulse-label">Tasks Completed</div>
          </div>
          <div className="pulse-divider" />
          <div className="pulse-item">
            <div className="pulse-value">
              {nextMilestone ? `${nextMilestone.tas_title} \u2014 ${moment(nextMilestone.tas_start_date).format('MMM D')}` : 'No upcoming tasks'}
            </div>
            <div className="pulse-label">Next Milestone</div>
          </div>
        </div>

            <div className="proj-card" style={{ display: 'flex', flexDirection: 'column', flexShrink: 0 }}>
              <div className="proj-card-header">
                <span>Tasks</span>
                <Button size="small" variant="contained" startIcon={<AddIcon />} onClick={() => navigationHandler(4)} sx={{ fontWeight: 700, fontSize: '0.72rem' }}>
                  New Task
                </Button>
              </div>
              <div className="task-list" style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 720px)', minHeight: '150px' }}>
                {displayTasks.length > 0 ? displayTasks.map((t) => {
                  const meta = getStatusMeta(t);
                  const emp = employee_list.find((e) => e.id === t.tas_emp_id);
                  const empName = emp?.employee_name || 'Unassigned';
                  return (
                    <Stack key={t.tas_id} direction="row" alignItems="center" spacing={1.5} className="task-row">
                      <Box className="task-main" sx={{ flex: 1, minWidth: 0 }}>
                        <div className="task-name">{t.tas_title}</div>
                        <div className="task-time">{moment(t.tas_start_date).fromNow()}</div>
                      </Box>
                      <Box sx={{ flexShrink: 0 }}>
                        <Chip size="small" label={meta.label} sx={{ bgcolor: meta.bg, color: meta.color, fontWeight: 600, fontSize: '0.7rem' }} />
                      </Box>
                      <Stack direction="row" alignItems="center" spacing={0.75} sx={{ flexShrink: 0, width: 140, minWidth: 0 }}>
                        <Avatar sx={{ width: 26, height: 26, fontSize: '0.68rem', bgcolor: '#3fa7d6', flexShrink: 0 }}>
                          {getInitials(empName)}
                        </Avatar>
                        <Typography noWrap variant="body2" title={empName} sx={{ fontSize: '0.78rem', color: '#444', fontWeight: 500, minWidth: 0 }}>
                          {empName}
                        </Typography>
                      </Stack>
                    </Stack>
                  );
                }) : (
                  <div className="task-empty">No tasks found</div>
                )}
              </div>
            </div>

            {/* Project Overview accordions moved down */}
            <div className="proj-card" style={{ flex: '1 1 auto', minHeight: 0, maxHeight: 'calc(100vh - 633px)', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
              <div className="proj-card-header"><span>Project Overview</span></div>
              <Box sx={{ flex: 1, overflowY: 'auto', p: '4px 12px 12px' }}>
                <DetailCard task comp_id={props.comp_id} projId={props.id} tasks={visibleTasks} />
                <DetailCard art comp_id={props.comp_id} projId={props.id} employee={employee_list} tasks={project_tasks} />
              </Box>
            </div>
        </div>

        {/* RIGHT COLUMN */}
        <div style={{ width: '34%', flexShrink: 0, height: '100%', overflow: 'hidden' }}>
            <Stack spacing={1.25} sx={{ height: 'calc(100vh - 236px)', overflow: 'hidden' }}>
              {/* Project Details */}
              <div className="proj-card" style={{ flex: '0 1 auto', maxHeight: '300px', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="proj-card-header"><span>Project Details</span></div>
                <Box sx={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
                  {renderRow('Status', statusLabel)}
                  {renderRow('Start Date', moment(props.start_date.replace(/Z/g, '')).format('D MMM YYYY'))}
                  {renderRow('End Date', moment(props.end_date.replace(/Z/g, '')).format('D MMM YYYY'))}
                  {renderRow('Description', props.project_details.pro_description)}
                  {renderRow('Plan Version', props.project_details.active_plan_version)}
                  {renderRow('Sponsor', props.project_details.pro_sponsors_id)}
                  {renderRow('Customer', customerName)}
                  {renderRow('Manager', managerName)}
                  {renderRow('Price', props.project_details.pro_price ? `${props.project_details.pro_price} ${props.project_details.pro_currency || 'USD'}` : null)}
                  {renderRow('Self Pay', props.project_details.pro_self_pay ? 'Yes' : 'No')}
                  {renderRow('Primary Payer', props.project_details.pro_primary_payer)}
                  {renderRow('Secondary Payer', props.project_details.pro_secondary_payer)}
                  {renderRow('Program', programName)}
                  {placeholderFields.map(({ field, type, fallback }) => (
                    isFieldVisible(field) && (
                      <React.Fragment key={field}>
                        {renderRow(
                          getFieldLabel(field, fallback),
                          type === 'date'
                            ? (props.project_details[field] ? moment(props.project_details[field]).format('MM/DD/YYYY') : '')
                            : (props.project_details[field] ?? '')
                        )}
                      </React.Fragment>
                    )
                  ))}
                </Box>
              </div>

              {/* Locations Card with embedded map */}
              <div className="proj-card" style={{ flex: '0 0 auto', maxHeight: '260px', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="proj-card-header"><span>Locations ({props.locations?.length || 0})</span></div>
                <Box sx={{ flex: 1, overflowY: 'auto' }}>
                  <Box sx={{ p: '8px' }}>
                    <MapsBar
                      mapsData={generateMapsData()}
                      user={props.user}
                      hideMap={showMap}
                      toggleMap={toggleMap}
                      currentProjectLocation={props.locations?.[0] || {}}
                    />
                  </Box>
                  <Box>
                    {(props.locations && props.locations.length > 0) ? props.locations.map((loc, index) => (
                      <div key={index} className="loc-row">
                        <i className="fas fa-map-marker-alt" style={{ color: '#3fa7d6', marginTop: 3 }}></i>
                        <span>{[loc.loc_addr_line1, loc.loc_addr_line2, loc.loc_city, loc.loc_state, loc.loc_zip].filter(Boolean).join(', ') || 'No address'}</span>
                      </div>
                    )) : (
                      <div className="loc-row" style={{ color: '#999' }}>No locations</div>
                    )}
                  </Box>
                </Box>
              </div>

              {/* Notes */}
              <div className="proj-card" style={{ flex: '1 1 auto', minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
                <div className="proj-card-header">
                  <span>Notes</span>
                </div>
                <Box sx={{ flex: 1, overflowY: 'auto', p: '10px 12px', fontSize: '0.88rem', color: '#555' }}>
                  {props.project_details.pro_description || 'No notes yet.'}
                </Box>
              </div>
            </Stack>
        </div>
      </div>
      </>
    );
  } else if (contextMenu === 2) {
    content = (
      <Dialog fullWidth={true} maxWidth={'sm'} open={contextMenu === 2} onClose={() => navigationHandler(0)}>
        <DialogContent>
          <CustomerForm
            history={props.history}
            isFormValidated={props.isFormValidated}
            customerStatus={customerStatus}
            customerType={customerType}
            states={props.states}
            empList={props.empList}
            tasklist={project_tasks}
            loc_list={loc_list}
            edit
            comp_id={props.comp_id}
            cusDets={props.customer_details[0]}
            pId={props.id}
            pManagerId={props.pManagerId}
            user={props.user}
          />
        </DialogContent>
      </Dialog>
    );
  } else if (contextMenu === 3) {
    content = (
      <Dialog fullWidth={true} maxWidth={'sm'} open={contextMenu === 3} onClose={() => navigationHandler(0)}>
        <DialogContent>
          <ProjectForm
            user={props.user}
            edit
            comp_id={props.comp_id}
            history={props.history}
            mapRender={"proj"}
            isFormValidated={props.isFormValidated}
            project_details={{
              ddd_id: props.project_details.DDD_ID,
              active_plan_version: props.project_details.active_plan_version,
              pro_program_id: props.project_details.pro_program_id,
              projId: props.project_details.pro_id,
              pTitle: props.project_details.pro_title,
              pDesc: props.project_details.pro_description,
              pCustomer: props.project_details.pro_customer_id,
              pManager: props.project_details.pro_manager_id,
              pSponsor: props.project_details.pro_sponsors_id,
              pstrtDate: props.project_details.pro_starts_on?.split('T')[0],
              pEndDate: props.project_details.pro_ends_on?.split('T')[0],
              pPrice: props.project_details.pro_price,
              pCurrency: 'USD',
              pLoc: !!props.project_details.locations ? getProjectLocation() : [],
              pSelfPay: props.project_details.pro_self_pay,
              pPrimaryPayer: props.project_details.pro_primary_payer,
              pSecondaryPayer: props.project_details.pro_secondary_payer,
              place01char: props.project_details.place01char,
              place02char: props.project_details.place02char,
              place03char: props.project_details.place03char,
              place04date: props.project_details.place04date,
              place05date: props.project_details.place05date,
              place06number: props.project_details.place06number,
              place07number: props.project_details.place07number,
            }}
            customerName={props.project_details.customer_details[0].cus_name}
            customerList={props.project_details.customer_details}
            proj_Employees={props.empList}
            empList={employee_list}
            contactList={props.project_details.contacts}
            locList={loc_list}
            taskList={project_tasks}
            updateProject={() => {
              navigationHandler(0);
              props.updateProject();
            }}
            empStatus
            currency
            frequency
            payerList={payerList}
          />
        </DialogContent>
      </Dialog>
    );
  }

  return (
    <div style={{ height: 'calc(100vh - 200px)', overflow: 'hidden' }}>
      {loading ? (
        <div className="d-flex justify-content-center" style={{ height: '100%' }}>
          <div className="spinner-border text-primary" style={{ width: '3rem', height: '3rem' }} role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <div style={{ height: '100%', padding: '8px' }}>{content}</div>
      )}
    </div>
  );
};

export default Home;
